var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95801 25.4997V9.91634C4.95801 4.24967 6.37467 2.83301 12.0413 2.83301H21.958C27.6247 2.83301 29.0413 4.24967 29.0413 9.91634V24.083C29.0413 24.2813 29.0413 24.4797 29.0272 24.678M11.333 9.91634H22.6663M11.333 14.8747H18.4163M8.99551 21.2497H29.0413V26.208C29.0413 28.9422 26.8172 31.1663 24.083 31.1663H9.91634C7.18217 31.1663 4.95801 28.9422 4.95801 26.208V25.2872C4.95801 23.063 6.77134 21.2497 8.99551 21.2497Z",
    stroke: "#005B98",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseAdd);
export default __webpack_public_path__ + "static/media/CourseAdd.89df2228c52de3963a2148905ec76266.svg";
export { ForwardRef as ReactComponent };